/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ViewEvent } from 'client-code/livelog-events';

import { LivelogEventsServiceRepositoryImpl } from '../impls/LivelogEventsServiceRepositoryImpl';
import { ILivelogEventsService, ILivelogEventsServiceRepository } from '../interfaces';
import { TServicesParams } from '../types';

export class LivelogEventsService implements ILivelogEventsService {
    private mLivelogEventsServiceRepository: ILivelogEventsServiceRepository;

    public constructor(params: TServicesParams) {
        this.mLivelogEventsServiceRepository = new LivelogEventsServiceRepositoryImpl(params);
    }

    /**
     * @inheritdoc
     */
    public async postViewEvents(viewEvents: Array<ViewEvent>): Promise<void> {
        await this.mLivelogEventsServiceRepository.postViewEvents(viewEvents);
    }
}
